
import { useState } from 'react';
import { BluetoothDevice } from '../PaymentContextTypes';

export const useBluetoothDevices = () => {
  const [bluetoothDevices, setBluetoothDevices] = useState<BluetoothDevice[]>([]);
  const [isScanning, setIsScanning] = useState<boolean>(false);
  const [connectedDevice, setConnectedDevice] = useState<BluetoothDevice | null>(null);
  const [availableDevices, setAvailableDevices] = useState<BluetoothDevice[]>([]);

  // Generate a unique ID without relying on external packages
  const generateId = () => {
    return 'id_' + Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
  };

  const addBluetoothDevice = (
    device: Omit<BluetoothDevice, 'id' | 'connected' | 'device' | 'canTransfer'>,
    deviceObject: any
  ) => {
    const newBluetoothDevice: BluetoothDevice = {
      id: generateId(),
      connected: false,
      canTransfer: false,
      device: deviceObject,
      ...device,
    };
    setBluetoothDevices((prevDevices) => [...prevDevices, newBluetoothDevice]);
  };

  const updateBluetoothDeviceConnection = (id: string, connected: boolean) => {
    setBluetoothDevices((prevDevices) =>
      prevDevices.map((device) =>
        device.id === id ? { ...device, connected } : device
      )
    );
  };

  const updateBluetoothDeviceTransfer = (id: string, canTransfer: boolean) => {
    setBluetoothDevices((prevDevices) =>
      prevDevices.map((device) =>
        device.id === id ? { ...device, canTransfer } : device
      )
    );
  };

  const removeBluetoothDevice = (id: string) => {
    setBluetoothDevices((prevDevices) =>
      prevDevices.filter((device) => device.id !== id)
    );
  };

  const clearBluetoothDevices = () => {
    setBluetoothDevices([]);
  };

  const startScan = () => {
    setIsScanning(true);
  };
  
  const stopScan = () => {
    setIsScanning(false);
  };
  
  const connectToDevice = (device: BluetoothDevice) => {
    setConnectedDevice(device);
  };
  
  const disconnectDevice = () => {
    setConnectedDevice(null);
  };

  return {
    bluetoothDevices,
    addBluetoothDevice,
    updateBluetoothDeviceConnection,
    updateBluetoothDeviceTransfer,
    removeBluetoothDevice,
    clearBluetoothDevices,
    isScanning,
    startScan,
    stopScan,
    connectedDevice,
    setConnectedDevice,
    connectToDevice,
    disconnectDevice,
    availableDevices,
  };
};
